import NewStaticTable from "components/staticTable/NewStaticTable"
import Modal from "global/Modal/Modal"
import React, { useEffect, useState } from "react"
import { addEditDataAPI, getAPI } from "services/CRUDServices"
import { getPrice } from "tools/functions/Methods"
import { CreditHistoryColumns } from "./columns"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { addEditUrls } from "services/api.enums"
import { toast } from "react-toastify"
import InputNumber from "global/InputNumber/InputNumber"

interface ClearingProps {
  open: boolean
  setOpen: (open: boolean) => void
  currentData: {
    id: number
   findAllByConsignmentPriceFromHub:{
    totalPayable: number
   } 
    creditRecipientHubId: number
  }
  refreshTable: () => void
}

const Clearing: React.FC<ClearingProps> = ({
  open,
  setOpen,
  currentData,
  refreshTable,
}) => {
  const [rawData, setRawData] = useState<any[]>([])
  const [loading, setLoading] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [payAmounts, setPayAmounts] = useState<Record<number, number>>({})

  useEffect(() => {
    setLoading(true)
    getAPI(
      `/core-api/hub_credit/getClearingCreditTo/${currentData.creditRecipientHubId}/${currentData.id}`
    )
      .then((res) => {
        const data = res.data.payload.map((item: any) => ({
          ...item,
          settlementMonth:
            item.creditValidTo?.year + "/" + item.creditValidTo?.month,
          totalPayable: item.shareCalculationResult.totalPayable,
        }))
        setRawData(data)
      })
      .catch(() => toast.error("خطا در دریافت داده‌ها"))
      .finally(() => setLoading(false))
  }, [currentData])

  const handleAmountChange = (id: number, value: number) => {
    setPayAmounts((prev) => ({ ...prev, [id]: value }))
  }

  const totalEntered = Object.values(payAmounts).reduce((sum, v) => sum + v, 0)

  const tableData = rawData.map((item) => ({
    ...item,
    totalPayable: getPrice(item.totalPayable),
    payAmount: (
      <InputNumber
        label='مبلغ'
        name='price'
        handleChange={(name, val) => {
          const numberVal = Number(val)
          handleAmountChange(item.id, numberVal)
        }}
        values={payAmounts[item.id] ?? ""}
        wrapperClassName='w-[10rem] mx-auto'
      />
    ),
  }))

  const columnsWithInput = [
    ...CreditHistoryColumns,
    { header: "مبلغ پرداختی", accessor: "payAmount", id: "payAmount" },
  ]

  const onSubmit = async () => {
    if (totalEntered > -currentData?.findAllByConsignmentPriceFromHub?.totalPayable) {
      toast.error("مجموع مبالغ وارد شده نباید بیشتر از مبلغ تهاتر باشد ")
      return
    }

    const clearingList = Object.entries(payAmounts)
      .filter(([, amount]) => amount > 0)
      .map(([id, amount]) => ({ creditId: Number(id), amount }))

    try {
      setIsSubmitting(true)
      await addEditDataAPI(addEditUrls.changeSettlementCredit, "put", {
        sourceCredit: currentData.id,
        amount: Object.values(payAmounts).reduce((sum, v) => sum + v, 0),
        clearingCreditDtoList: clearingList,
      })
      toast.success("تهاتر با موفقیت انجام شد")
      setOpen(false)
      refreshTable()
    } catch {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal visible={open} setVisible={setOpen} title='تهاتر'>
      <p className=' font-bold'>
        مبلغ قابل تهاتر:{" "}
        <span dir='ltr'>{getPrice(-currentData?.findAllByConsignmentPriceFromHub.totalPayable)}</span>
      </p>
      <p className='mt-2  font-bold'>مجموع واردشده: {getPrice(totalEntered)}</p>
      <NewStaticTable
        data={tableData}
        column={columnsWithInput}
        ignoreRedux
        loading={loading}
        HoleClassName='w-[40rem]'
      />
      <div className='btnForm'>
        <SimpleButton
          handelClick={() => setOpen(false)}
          text='انصراف'
          className='text-tomato'
        />
        <SimpleButton
          type='submit'
          text='تایید'
          className='full-tomato-btn'
          loading={isSubmitting}
          disabled={totalEntered === 0}
          handelClick={onSubmit}
        />
      </div>
    </Modal>
  )
}

export default Clearing
